module.exports = __webpack_public_path__ + "img/202311_03.980b0f0c.jpg";